<template>
  <div class="my-5 text-center" v-if="isPagination()">
    <span class="mr-3">
      <button
        :class="{ isDisabled: isFirstPageDisabled() }"
        @click="decrementPage()"
      >
        <doe-icon icon="chevronLeft" style="margin-top:5px;" />
      </button>
    </span>
    <span v-for="(page, index) in totalPages" :key="index">
      <button
        v-if="isWithinShoulder(page)"
        :class="{ isActive: isActivePage(page) }"
        @click="changePage(page)"
      >
        {{ page }}
      </button>
      <p v-if="isEllipsis(page)">
        <doe-icon icon="ellipsis" />
      </p>
    </span>
    <span class="ml-3">
      <button :class="{ isDisabled: isLastPageDisabled() }" @click="incrementPage()">
        <doe-icon icon="chevronRight" style="margin-top:5px;" />
      </button>
    </span>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "DoePagination",
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      required: true,
      default: 10
    },
    rows: {
      type: Array,
      required: true
    },
    settings: {
      type: Object
    }
  },
  components: {
    DoeIcon
  },
  data() {
    return {
      truncateAt: 1000,
      shoulderAt: 1000
    };
  },
  methods: {
    isPagination() {
      if (this.totalPages > 1) {
        return true;
      }
    },
    isActivePage(page) {
      return this.currentPage === page;
    },
    isFirstPageDisabled() {
      return this.currentPage === 1;
    },
    isLastPageDisabled() {
      return this.currentPage === this.totalPages;
    },
    isWithinShoulder(page) {
      let lowerLimit = this.shoulderAt;
      let upperLimit = this.totalPages - this.shoulderAt;
      if (page <= lowerLimit || page > upperLimit) {
        return true;
      } else {
        return false;
      }
    },
    isEllipsis(page) {
      if (this.totalPages < this.truncateAt) {
        return false;
      }
      if (page === this.shoulderAt + 1) {
        return true;
      }
    },
    incrementPage() {
      if (this.currentPage < this.totalPages) {
        this.changePage(this.currentPage + 1);
      }
    },
    decrementPage() {
      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1);
      }
    },
    changePage(page) {
      this.$emit("click", {
        itemsPerPage: this.itemsPerPage,
        page: page,
        totalPages: this.totalPages,
        totalItems: this.totalItems
      });
    }
  },
  computed: {
    totalItems() {
      return this.rows.length;
    },
    totalPages() {
      return this.totalItems / this.itemsPerPage;
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  @apply cursor-pointer inline font-light font-sans leading-relaxed mx-1 subpixel-antialiased text-3xl text-blue-900;
  height: 36px;
  width: 36px;
}
button.isActive {
  @apply bg-gray-500 rounded-full;
}
button.isDisabled {
  @apply text-gray-500;
}
</style>
